import { render, staticRenderFns } from "./contentCourseLecturePhoto.vue?vue&type=template&id=2ce9e3e2&"
import script from "./contentCourseLecturePhoto.vue?vue&type=script&lang=js&"
export * from "./contentCourseLecturePhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports